import React from 'react';

import FormError from '../../gd-form/common/form-error/form-error';

export default function FormRow(props) {

    return (
        <div className="row">
            <div className="label">{props.title}</div>
            <div className="element">
                {props.children}
                <FormError form={props.form} name={props.name} />
            </div>
        </div>
    );
}